import script from "./Textarea.vue?vue&type=script&setup=true&lang=js"
export * from "./Textarea.vue?vue&type=script&setup=true&lang=js"

import "./Textarea.vue?vue&type=style&index=0&id=04a7187e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a7187e"]])

export default __exports__